@let forbiddenPermissionsMessage = 'general.forbidden_action' | translate;
<div>
  <h4 class="mb-2">
    {{ 'page.general_settings.tax-title' | translate }}
  </h4>
  <div class="mb-2 subtitle">
    {{ 'page.general_settings.tax-subtitle' | translate }}
  </div>
</div>
<form [formGroup]="form">
  <div class="row">
    <div class="w-100">
      <div>
        <div class="form-group">
          <label for="generalManager">
            {{ 'page.general_settings.tax.general_manager' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['generalManager'] | formControlInvalid) ||
              form.controls['generalManager'].invalid
            "
            type="text"
            class="rounded-0"
            id="generalManager"
            nz-input
            formControlName="generalManager"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onVatChange()"
          />
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="form-group input-field">
          <label for="localCourt">
            {{ 'page.general_settings.tax.local_court' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['localCourt'] | formControlInvalid) ||
              form.controls['localCourt'].invalid
            "
            type="text"
            class="rounded-0"
            id="localCourt"
            nz-input
            formControlName="localCourt"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onVatChange()"
          />
        </div>

        <div class="form-group input-field">
          <label for="tradeRegisterNumber">
            {{ 'page.general_settings.tax.register_number' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['tradeRegisterNumber'] | formControlInvalid) ||
              form.controls['tradeRegisterNumber'].invalid
            "
            type="text"
            class="rounded-0"
            id="tradeRegisterNumber"
            nz-input
            formControlName="tradeRegisterNumber"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onVatChange()"
          />
        </div>
      </div>
      <div style="display: flex; justify-content: space-between">
        <div class="form-group input-field">
          <label for="vatId">
            {{ 'page.general_settings.tax.umst' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['vatId'] | formControlInvalid) ||
              form.controls['vatId'].invalid
            "
            type="text"
            class="rounded-0"
            id="vatId"
            nz-input
            formControlName="vatId"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onVatChange()"
          />
        </div>

        <div class="form-group input-field">
          <label for="taxIdentificationNumber">
            {{ 'page.general_settings.tax.vat_number' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['taxIdentificationNumber'] | formControlInvalid) ||
              form.controls['taxIdentificationNumber'].invalid
            "
            type="text"
            class="rounded-0"
            id="taxIdentificationNumber"
            nz-input
            formControlName="taxIdentificationNumber"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onVatChange()"
          />
        </div>
      </div>
    </div>
  </div>
</form>
